module.exports = __webpack_public_path__ + "media/images/company_logo/company_logo-ef9a9589e6b1946a0c75230c375f772d.png";